/** Site languages: Czech is the source and the fallback, the rest come from scripts/seed. Shared by the
 * language switcher and scripts/generate-catalog-terms.ts, so a language can't be offered without its
 * generated translation file. */
export const languageCodes = ['cs', 'en', 'da', 'de', 'es', 'fr', 'it', 'nl', 'pl', 'sk'] as const;

export type LanguageCode = (typeof languageCodes)[number];

/**
 * Each language's name in itself, as lib.spa-components' language switcher shows it (it doesn't export its
 * names), for links to another language's version of a page.
 */
export const languageNames: Record<LanguageCode, string> = {
  cs: 'Čeština',
  en: 'English',
  da: 'Dansk',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  nl: 'Nederlands',
  pl: 'Polski',
  sk: 'Slovenčina',
};
